// Func = limiting Scope for this file
(function () {

	$(".read-more-blog").click(function () {

		var changeTxtBtn = $(this);

		($(this).text() == "Read more") ? $(this).text("Read less") : $(this).text("Read more");

		$(this).prev('div.full-content').slideToggle();

	});

	function resizeWindow() {

	}
	function scrollDown() {
		const top = window.scrollY;
		const headerEl = document.getElementById('header');
		if (top > 40) {
			headerEl.classList.add('scroll');
		} else {
			headerEl.classList.remove('scroll');
		}
		let animatedEl = document.getElementsByClassName('animate-fade-2');
		const h = window.innerHeight;
		var i;
		for (i = 0; i < animatedEl.length; i++) {
			var viewportOffset = animatedEl[i].getBoundingClientRect();
			let topPos = viewportOffset.top;
			//animatedEl[i].innerHTML = topPos;
			if (topPos <= h * 0.6) {
				animatedEl[i].classList.add('fade-in');
			}
		}
		if(document.querySelectorAll('.wrapper-sub-menu') !== undefined ){
			if (document.querySelectorAll('.wrapper-sub-menu').length > 0) {
				let topSubmenu = document.querySelectorAll('.wrapper-sub-menu').offsetTop;
				if (top >= (topSubmenu - 85)) {
					document.querySelectorAll('.content-sub-menu').addClass('fixed');
				}
				else {
					document.querySelectorAll('.content-sub-menu').removeClass('fixed');
				}
			}

		}
	}

	if (!document.getElementById('home')) {
		document.getElementById('header').classList.add('internalheader');
	}
	// Book now functionality
	$('#menu-trigger').click(function () {
		$('.menu-content').fadeToggle();
	});

	$('#menu-trigger').click(function (e) {
		$('.link').fadeOut(240);
		var $this = $(this);
		$this.toggleClass('on-change');
		if ($this.hasClass('on-change')) {
			$this.text('close');
		} else {
			$this.text('menu');
			$('.link').fadeIn(240);
		}
		e.preventDefault();
	});

	$('#menu-trigger-contact').click(function () {
		$('.contact-content').fadeToggle();
	});

	$('#menu-trigger-contact').click(function (e) {
		$('#menu-trigger').fadeOut(270);
		var $this = $(this);
		$this.toggleClass('on-change');
		if ($this.hasClass('on-change')) {
			$this.text('close');
		} else {
			$this.text('contact us');
			$('#menu-trigger').fadeIn(270);
		}
		e.preventDefault();
	});

	$('.cover-video').click(function () {
		$(this).fadeOut(270);
		$('.video-content')[0].play();
	});


	// Main Nav Dropdown
	const imagesMenu = function () {

		let getItemMenu = [...document.querySelectorAll('#primary-nav li')] || [];
		let getImagesMenu = [...document.querySelectorAll('.image-hover')] || [];
		let active_menu_items = document.querySelectorAll('#primary-nav li a.active');
		let active_image;
		if (active_menu_items.length == 0) {
			active_image = $(getImagesMenu[0]);
			active_image.addClass('show');
		}
		getItemMenu.forEach(function (itemMenu, i) {
			if (itemMenu.querySelector('a').classList.contains('active')) {
				active_image = $(getImagesMenu[i]);
				active_image.addClass('show');
			}
			itemMenu.addEventListener('mouseover', function () {
				//const active_image = document.querySelector('.image-hover.active');
				//active_image.classList.remove('show__selected');
				getImagesMenu.forEach(function (itemImage) {
					itemImage.classList.remove('show');
				})
				$(getImagesMenu[i]).addClass('show');
				// itemMenu.classList.remove('hover');
				// let classItemMenu = itemMenu.className;


				// getImagesMenu.forEach(function( itemImage ) {

				// 	itemImage.classList.remove('show');
				// 	if( itemImage.classList.contains(classItemMenu) ) {
				// 		itemImage.classList.add('show');
				// 	}
				// })
			});
			itemMenu.addEventListener('mouseout', function () {
				getImagesMenu.forEach(function (itemImage) {
					itemImage.classList.remove('show');
				});
				active_image.addClass('show');
			})
		})

	}

	imagesMenu();

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function () {
			$(this).addClass("hover");
			$('ul.submenu', this).fadeIn(200);
		}, function () {
			$(this).removeClass("hover");
			$('ul.submenu', this).fadeOut(200);
		});



		showDatepicker('#checkIn', '#checkOut');
		showDatepicker('#check_in_safe', '#check_out_safe');
		showDatepicker('#check_in_contact', '#check_out_contact');



		// Map: Return to previous page button. Change body id to match map template's name.
		$('body#map #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		$('body#map #content').prepend('<a class="btn return-from-map ada-map" href="ada-map">ADA Map</a>');
	});

	$(window).on("load",function () {
		setTimeout(function () {
			var rellax = new Rellax('.rellax');
		}, 100)

		setTimeout(function () {
			$('.top-content__copy').addClass('animate');
		}, 300)

		setTimeout(function () {
			$('.top-content__title').addClass('animate');
		}, 300)

	});

	$(".toggle-tabs li").click(function () {
		$(this).addClass('active-tab').parents('ul.toggle-tabs').find('li').not($(this)).removeClass('active-tab');
		var currentTabIndex = $(this).index();
		$('.content-box:eq(' + currentTabIndex + ')').addClass('active-content-box').parents('.tabbed-content-wrap').find('.content-box').not($('.content-box:eq(' + currentTabIndex + ')')).removeClass('active-content-box');
	});

}());